export default __webpack_public_path__ + "static/media/signature.98b67efa.png";